import { View, Text, StyleSheet } from '@react-pdf/renderer';
import React from 'react';
import { useTemplateColors } from 'PDF/TemplateEngine/TemplateColorsContext';
import PDFSignatureImage from './PDFSignatureImage';
import SpecialistBlock from './SpecialistBlock';

const makeStyles = (colors) =>
  StyleSheet.create({
    container: {
      display: 'flex',
      flexDirection: 'row',
      gap: '1cm',
      marginTop: '0.5cm',
    },
    signatureSection: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      minHeight: '6cm',
    },
    sectionTitle: {
      fontSize: '12px',
      fontFamily: 'Helvetica-Bold',
      color: colors.primary,
      textTransform: 'uppercase',
      letterSpacing: '0.3px',
      marginBottom: '0.4cm',
      textAlign: 'center',
    },
    signatureContainer: {
      backgroundColor: colors.white,
      borderRadius: '0.2cm',
      padding: '0.4cm',
      border: `1px solid ${colors.border}`,
      boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
      marginTop: '0.3cm',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      // Altura FIJA = maxHeight de la imagen (3cm) + padding vertical (2 × 0.4cm).
      // Con minHeight, una firma alta (PNG recortado a la tinta) agrandaba su caja y
      // la dejaba desalineada respecto de la otra.
      height: '3.8cm',
      width: '100%',
    },
    signatureImage: {
      maxWidth: '5.5cm',
      maxHeight: '3cm',
      objectFit: 'contain',
    },
    recepcionistInfo: {
      backgroundColor: colors.lightBg,
      borderRadius: '0.2cm',
      padding: '0.4cm',
      border: `1px solid ${colors.border}`,
      marginBottom: '0.3cm',
      textAlign: 'left',
      minHeight: '2.5cm',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
    },
    recepcionistName: {
      fontSize: '11px',
      fontFamily: 'Helvetica-Bold',
      color: colors.darkText,
      marginBottom: '0.1cm',
      textTransform: 'capitalize',
      textAlign: 'left',
    },
    recepcionistCharge: {
      fontSize: '9px',
      fontFamily: 'Helvetica',
      color: colors.bodyText,
      lineHeight: 1.3,
      textTransform: 'capitalize',
      textAlign: 'left',
    },
  });

const SignatureBlock = (props) => {
  const {
    specialistSignature,
    recepcionistName,
    recepcionistSignature,
    recepcionistCharge,
    specialistName,
    specialistEspecialidad,
    specialistCargo,
    specialistOtros,
  } = props;
  const { colors } = useTemplateColors();
  const styles = makeStyles(colors);

  return (
    <View style={styles.container}>
      {/* Sección del Especialista */}
      <View style={styles.signatureSection}>
        <Text style={styles.sectionTitle}>Especialista</Text>
        <SpecialistBlock
          specialist={{
            name: specialistName,
            especialidad: specialistEspecialidad,
            cargo: specialistCargo,
            otros: specialistOtros,
          }}
        />
        <View style={styles.signatureContainer}>
          <PDFSignatureImage src={specialistSignature} style={styles.signatureImage} />
        </View>
      </View>

      {/* Sección de Recepción */}
      <View style={styles.signatureSection}>
        <Text style={styles.sectionTitle}>Recepción del Cliente</Text>
        <View style={styles.recepcionistInfo}>
          <Text style={styles.recepcionistName}>{recepcionistName}</Text>
          {recepcionistCharge && (
            <Text style={styles.recepcionistCharge}>{recepcionistCharge}</Text>
          )}
        </View>
        <View style={styles.signatureContainer}>
          <PDFSignatureImage src={recepcionistSignature} style={styles.signatureImage} />
        </View>
      </View>
    </View>
  );
};

export default SignatureBlock;
